import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MMEMediaVehicles from './MMEMediaVehicles';
import MMEReportOptions from './MMEReportOptions';

class MMEEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div className="mme-viewer-main-wrapper">
        <div className="column">
          <MMEMediaVehicles
            data-test="MediaVehicleComp"
            selectedMediaVehicleIndex={this.props.selectedMediaVehicleIndex}
            mediaList={this.props.mediaList}
            handleSelect={this.props.handleSelect}
            onChangeProperty={this.props.onChangeProperty}
            vehicleCodeCount={this.props.vehicleCodeCount}
          />
        </div>
        <div className="column">
          <MMEReportOptions
            data-test="ReportOptionsComp"
            statementList={this.props.statementList}
            updateSelectedAction={this.props.updateSelectedAction}
            selectedStatementVariables={this.props.selectedStatementVariables}
            updateReportType={this.props.updateReportType}
            selectedReportType={this.props.selectedReportType}
            dimensionList={this.props.dimensionList}
            updateDimensionType={this.props.updateDimensionType}
            selectedDimensionType={this.props.selectedDimensionType}
            onChangeProperty={this.props.onChangeProperty}
          />
        </div>
      </div>
    );
  }
}

MMEEditor.propTypes = {
  mediaList: PropTypes.shape({}),
  statementList: PropTypes.shape({}),
  updateSelectedAction: PropTypes.func,
  selectedStatementVariables: PropTypes.instanceOf(Array),
  handleSelect: PropTypes.func,
  selectedMediaVehicleIndex: PropTypes.number,
  updateReportType: PropTypes.func,
  selectedReportType: PropTypes.string,
  dimensionList: PropTypes.shape({}),
  onChangeProperty: PropTypes.func,
  vehicleCodeCount: PropTypes.number,
  updateDimensionType: PropTypes.func,
  selectedDimensionType: PropTypes.number,
};

export default MMEEditor;
